import React from 'react';
import { Search, X, Mail } from 'lucide-react';

/**
 * EmailSearchBar - Compact search input for filtering emails with optional compose button
 */
const EmailSearchBar = ({
  searchQuery,
  setSearchQuery,
  resultCount,
  placeholder = 'Search emails...',
  onCompose,
  className = ''
}) => {
  return (
    <div className={`px-3 py-1.5 ${className}`}>
      <div className="flex items-center gap-2">
        <div className="relative flex-1">
          <Search size={14} className="absolute left-2.5 top-1/2 transform -translate-y-1/2 text-white" />
          <input
            type="text"
            placeholder={placeholder}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-8 pr-8 py-1.5 bg-black border border-gray-400 rounded-lg text-xs text-white placeholder-white focus:outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300 hover:bg-gray-900 transition-all"
            data-testid="email-search-input"
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery('')}
              className="absolute right-2.5 top-1/2 transform -translate-y-1/2 text-white hover:text-gray-300 transition-colors"
              data-testid="clear-search-btn"
            >
              <X size={14} />
            </button>
          )}
        </div>
        {onCompose && (
          <button 
            onClick={onCompose}
            className="px-4 py-2 bg-white hover:bg-gray-200 text-black rounded-lg text-sm font-semibold transition-colors flex items-center gap-2 whitespace-nowrap"
            data-testid="email-compose-btn"
          >
            <Mail size={16} />
            Compose
          </button>
        )}
      </div>
      {searchQuery && (
        <p className="text-[10px] text-gray-400 mt-0.5">
          {resultCount} result{resultCount !== 1 ? 's' : ''}
        </p>
      )}
    </div>
  );
};

export default EmailSearchBar;
